__turbopack_context__.v({
  "bannerBlur": "index-module-scss-module__FTJw4q__bannerBlur",
  "bannerBlur__disable": "index-module-scss-module__FTJw4q__bannerBlur__disable",
  "body": "index-module-scss-module__FTJw4q__body",
  "img": "index-module-scss-module__FTJw4q__img",
  "img__hero": "index-module-scss-module__FTJw4q__img__hero",
  "img__list": "index-module-scss-module__FTJw4q__img__list",
  "img__sidebar": "index-module-scss-module__FTJw4q__img__sidebar",
  "img__top": "index-module-scss-module__FTJw4q__img__top",
  "img__top__desktop": "index-module-scss-module__FTJw4q__img__top__desktop",
  "img__top__mobile": "index-module-scss-module__FTJw4q__img__top__mobile",
  "root": "index-module-scss-module__FTJw4q__root",
  "root__hero": "index-module-scss-module__FTJw4q__root__hero",
  "root__list": "index-module-scss-module__FTJw4q__root__list",
  "root__sidebar": "index-module-scss-module__FTJw4q__root__sidebar",
  "root__top": "index-module-scss-module__FTJw4q__root__top",
});
